import { createFileRoute } from "@tanstack/react-router";
import SearchAdvanced from "@/pages/SearchAdvanced";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/cauta/")({
  head: () => routeHead("/cauta/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SearchAdvanced />
  );
}
